/* eslint-disable global-require */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import './index.css';


function renderApp() {
  render(<App />, document.querySelector('#app'));
}

renderApp();
serviceWorker.register();
